const StoneAge = {
  id: '1',
  name: 'Stone Age'
};

export default StoneAge;
